var map = {
	"./astronaut.svg": 332,
	"./bg-pattern.svg": 764,
	"./bitmax.png": 765,
	"./check.png": 766,
	"./coins/Coin-BNB.png": 767,
	"./coins/Coin-BTCB.png": 768,
	"./coins/Coin-BTCS.png": 769,
	"./coins/Coin-CBM.png": 770,
	"./coins/Coin-SBY.png": 771,
	"./coins/Coin-unknown.png": 439,
	"./ledger-app.svg": 772,
	"./ledger-pin.svg": 773,
	"./logo.png": 774,
	"./og-image.png": 775,
	"./qr-code.png": 776,
	"./ranking-1.png": 777,
	"./ranking-2.png": 778,
	"./ranking-3.png": 779,
	"./social/github.svg": 780,
	"./social/medium.svg": 781,
	"./social/telegram.svg": 782,
	"./social/twitter.svg": 783,
	"./step1.svg": 784,
	"./step2.svg": 785,
	"./wallet-connect-wait.svg": 786,
	"./wallet-connected.svg": 787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 763;